module.exports = __webpack_public_path__ + "static/media/icon-location-n.fc12e26d.svg";